<template>
    <div class="tile tile-project" v-on:mouseleave="onToggleMenu(false)">
        <router-link :to="info.url">
            <header>{{ info.title }} <span title="More" v-on:mouseenter="onToggleMenu(true)"></span></header>
            <p>
                <template v-if="info.programs">
                    {{ getActiveListLength(info.programs, info.isArchived) === 1 ? "1 program" : getActiveListLength(info.programs, info.isArchived) + " programs" }}
                </template>
                <template v-else-if="info.studies">
                    {{ getActiveListLength(info.studies, info.isArchived) === 1 ? "1 study" : getActiveListLength(info.studies, info.isArchived) + " studies" }}
                </template>
                <template v-if="info.processStatus">
                    {{ getProcessStatus(info) }}
                </template>
                <small :title="$moment.utc(info.updateDate).format('DD/MM/YYYY')">Modified: {{ $moment.utc(info.updateDate).from() }}</small>
            </p>
        </router-link>
        <div class="title-menu" v-bind:class="{ 'open': isMenuOpen }" v-on:click="onToggleMenu(false)">
            <ul>
                <template v-if="!info.isArchived">
                    <li v-on:click="onRenameClick">Rename</li>
                    <li v-on:click="onCloneClick">Clone</li>
                    <li v-on:click="onArchiveClick(true)">Archive</li>
                </template>
                <template v-else>
                    <li v-on:click="onArchiveClick(false)">Unarchive</li>
                </template>
                <template v-if="allowDelete()">
                    <li v-on:click="onDeleteClick(false)">Delete</li>
                </template>
                <!--
                <template v-if="allowSetSeed()">
                    <li v-on:click="onSetSeedClick">Set seed value</li>
                </template>
                -->
                <template v-if="allowImportStudy()">
                    <li v-on:click="onImportStudyClick">Import a study</li>                    
                </template>
            </ul>
        </div>

        <Modal title="Set seed value" ref="modalSetSeed">
            <form v-on:submit="onSetSeedSubmit">
                <div class="input" type="text">
                    <label>
                        <span>Seed value</span>
                        <input type="text" ref="setSeedInput" placeholder="New seed value" :value="info.seed" />
                    </label>
                </div>

                <button class="right edit" v-bind:class="{ 'loading': isLoading }">Set seed</button>
            </form>
            <button class="left edit" v-on:click="onSuggestSeedClick()">Suggest seed</button>
            <button v-if="suggestedSeed != ''" class="left edit" v-on:click="onSuggestSeedInsertClick()">Insert seed: {{ suggestedSeed }}</button>
        </Modal>

        <Modal title="Rename" ref="modalRename">
            <form v-on:submit="onRenameSubmit">
                <div class="input" type="text">
                    <label>
                        <span>Name</span>
                        <input type="text" ref="renameNameInput" placeholder="New name" :value="info.title" />
                    </label>
                </div>

                <button class="right edit" v-bind:class="{ 'loading': isLoading }">Rename</button>
            </form>
        </Modal>


        <Modal title="ImportStudy" ref="modalImportStudy">            
            <form v-on:submit="onImportStudySubmit">
                <div class="input" type="text">
                    <label>
                        <span>Study title</span>
                        <input type="text" ref="importStudyTitle" placeholder="Study title" v-model="importStudyTitle" />
                    </label>
                </div>
                <div class="input" type="textarea">
                    <label>
                        Copy paste study json you want to import. Keys will automatically be corrected.
                        <textarea ref="importStudyInput" v-model="importStudyInput"></textarea>
                    </label>
                </div>
                <button class="right edit" v-bind:class="{ 'loading': isLoading }">Import now</button>
            </form>
        </Modal>
    </div>
</template>

<script>
    import Modal from "../Components/Modal.vue"
    export default {
        components: {
            Modal
        },
        props: {
            info: {
                type: Object,
                required: true
            }
        },
        data: () => ({
            isMenuOpen: false,
            isLoading: false,
            suggestedSeed: "",
            importStudyInput: "",
            importStudyTitle: ""
        }),
        methods: {
            onToggleMenu(open) {
                this.isMenuOpen = open;
            },
            allowDelete() {                
                return this.$store.state.member.isSuperAdmin;
            },
            allowSetSeed() {
                
                if (!this.$store.state.member.isSuperAdmin)
                    return false;
                
                return !this.NullOrUndefined(this.info.studyId);

                

            },
            allowImportStudy() {

                if (!this.$store.state.member.isSuperAdmin)
                    return false;

                if (this.NullOrUndefined(this.info.programId))
                    return false;

                if (this.NullOrUndefined(this.info.projectId))
                    return false;

                //this is special. But we cannot import a study under another study. Therefore we have to be above study level to import.
                return this.NullOrUndefined(this.info.studyId);

                

            },
            onImportStudyClick() {
                this.$refs.modalImportStudy.show();
                this.$nextTick(() => this.$refs.importStudyInput.focus())
            },
            onImportStudySubmit(e) {
                e.preventDefault();
                
                let studyInput = this.$refs.importStudyInput.value.trim();
                let importStudyTitle = this.$refs.importStudyTitle.value.trim();
                //debugger;
                if (studyInput === "")
                    return false;

                this.isLoading = true;

                let data = {
                    programId: this.info.programId,
                    projectId: this.info.projectId,
                    studyImportJson: studyInput,
                    title: importStudyTitle
                };

                this.$store.dispatch("importStudyJson", data).then((res) => {
                    this.isLoading = false;
                    this.$refs.modalImportStudy.hide();

                    this.$store.state.projects = [];
                    //reload all projects again
                    this.$store.dispatch("getActiveProjects").then(() => {
                    });

                }).catch((res) => {
                    this.isLoading = false;
                    this.$refs.modalImportStudy.hide();
                })                
            },
            onDeleteClick() {
                let data = {
                    projectId: this.info.projectId,
                    programId: this.info.programId,
                    studyId: this.info.studyId,
                    title: this.info.title.trim()
                };

                
                if (!this.NullOrUndefined(data.studyId)
                    && confirm("Are you sure you want to delete study " + data.title + " and all versions within.")) {
                    //delete projct                    
                    this.$store.dispatch("deleteStudy", data).then((res) => {
                       
                       
                        var currentProgram = null;
                        for (var i = 0; i < this.$store.state.projects.length; i++) {
                            var currentProject = this.$store.state.projects[i];
                            currentProgram = currentProject.programs.find(x => x.programId === data.programId);  
                            
                            if (!this.NullOrUndefined(currentProgram))
                            {
                                break;
                            }
                        }

                            
                        var deletedIndex = currentProgram.studies.findIndex(x => x.studyId === data.studyId);                        
                       
                        if (deletedIndex > -1) {
                            //debugger;
                            currentProgram.studies.splice(deletedIndex, 1);
                        }
                       

                    }).catch((res) => {

                    })

                    return;
                }
               

                if (!this.NullOrUndefined(data.programId)
                    && confirm("Are you sure you want to delete program " + data.title + " and all studies within.")) {
                    //delete projct
                    this.$store.dispatch("deleteProgram", data).then((res) => {
                        //debugger;
                        var currentProject = this.$store.state.projects.find(x => x.projectId === data.projectId)
                        var deletedIndex = currentProject.programs.findIndex(x=>x.programId === data.programId);
                        //debugger;
                        if (deletedIndex > -1) {
                            //debugger;
                            currentProject.programs.splice(deletedIndex, 1);
                        }
                    }).catch((res) => {

                    })

                    return;
                }
                             
                if (!this.NullOrUndefined(data.projectId)
                    && confirm("Are you sure you want to delete project " + data.title + " and all programs and studies within.")) {
                    //delete projct
                    this.$store.dispatch("deleteProject", data).then((res) => {
                        this.$store.state.projects = [];
                        //reload all projects again
                        this.$store.dispatch("getActiveProjects").then(() => {
                            this.importStudyInput = "";
                            this.importStudyTitle = ""
                        });
                    }).catch((res) => {

                    })

                    return;
                }
        
            },
            getUrlName(){
                if(this.$route.name.indexOf("projects") > -1)
                    return "Project";
                if(this.$route.name.indexOf("programs") > -1)
                    return "Program";
                if(this.$route.name.indexOf("studies") > -1)
                    return "Study";
            },
            getProcessStatus(info){
                if(!info.forecastVersions || info.forecastVersions.length === 0)
                    return info.processStatusName;

                return info.forecastVersions[0].processStatusName;
            },
            onCloneClick() {                
                let data = {
                    projectId: this.info.projectId,
                    programId: this.info.programId,
                    studyId: this.info.studyId,
                    title: this.GetWindowsCopyStyleTitle(this.info.title.trim())
                };

                this.$store.dispatch("clone" + this.getUrlName(), data).then((res) => {
                    this.$router.push(res.data.url)
                }).catch((res) => {

                })
            },
            onArchiveClick(isArchived) {
                this.info.isArchived = isArchived;

                if(this.info.programs){
                    for(let program of this.info.programs){
                        program.isArchived = isArchived;

                        for(let study of program.studies)
                            study.isArchived = isArchived;
                    }
                }

                if(this.info.studies){
                    for(let study of this.info.studies)
                        study.isArchived = isArchived;
                }

                let data = {
                    projectId: this.info.projectId,
                    programId: this.info.programId,
                    studyId: this.info.studyId,
                    isArchived: isArchived
                };

                this.$store.dispatch("archive" + this.getUrlName(), data);
            },
            onSuggestSeedClick() {
                //from https://stackoverflow.com/questions/7966559/how-to-convert-javascript-date-object-to-ticks
                var yourDate = new Date();  // for example

                // the number of .net ticks at the unix epoch
                var epochTicks = 621355968000000000;

                // there are 10000 .net ticks per millisecond
                var ticksPerMillisecond = 10000;

                // calculate the total number of .net ticks for your date
                var yourTicks = epochTicks + (yourDate.getTime() * ticksPerMillisecond);

                this.suggestedSeed = yourTicks;
            },
            onSuggestSeedInsertClick() {                
                this.$refs.setSeedInput.value = this.suggestedSeed;
                this.info.seed = this.suggestedSeed;
            },
            onSetSeedClick() {
                this.$refs.modalSetSeed.show();
                this.$nextTick(() => this.$refs.setSeedInput.focus())
            },
            onSetSeedSubmit(e) {
                e.preventDefault();

                let newValue = this.$refs.setSeedInput.value.trim();

                if (newValue === "")
                    return false;

                this.isLoading = true;

                let data = {
                    studyId: this.info.studyId,
                    seed: newValue
                };

                this.$store.dispatch("setSeedStudy", data).then((res) => {
                    this.isLoading = false;
                    this.$refs.modalSetSeed.hide();
                }).catch((res) => {
                    this.isLoading = false;
                    this.$refs.modalSetSeed.hide();
                })
            },
            onRenameClick() {
                this.$refs.modalRename.show();
                this.$nextTick(() => this.$refs.renameNameInput.focus())
            },
            onRenameSubmit(e) {
                e.preventDefault();

                let newValue = this.$refs.renameNameInput.value.trim();
                if(newValue == "")
                    return false;

                this.isLoading = true;
                this.info.title = newValue;

                let data = {
                    projectId: this.info.projectId,
                    programId: this.info.programId,
                    studyId: this.info.studyId,
                    title: newValue
                };

                this.$store.dispatch("rename" + this.getUrlName(), data).then((res) => {
                    this.isLoading = false;
                    this.$refs.modalRename.hide();
                }).catch((res) => {
                    this.isLoading = false;
                    this.$refs.modalRename.hide();
                })
            },
            getActiveListLength(list, isArchived){
                return list.filter(x => x.isArchived === isArchived).length;
            }
        }
    }
</script>